// Copyright (c) Move Closer 2022.

import { AuthProvider, Headers, Injectable } from '@movecloser/front-core'

import {
  GraphQLMiddleware,
  GraphQLMiddlewareBeforeResult,
  MutationOptions,
  QueryDefinition,
  QueryOptions
} from '../../../contexts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Injectable()
export class AuthGraphQLMiddleware implements GraphQLMiddleware {
  constructor (protected authProvider: AuthProvider) {}

  public beforeCall (
    definition: QueryDefinition,
    headers: Headers,
    query: MutationOptions | QueryOptions
  ): GraphQLMiddlewareBeforeResult {
    if (
      (typeof definition.meta.noAuth === 'boolean' && definition.meta.noAuth) ||
      !this.authProvider.check()
    ) {
      return { headers, query }
    }

    return {
      query,
      headers: {
        ...headers,
        ...this.authProvider.getAuthorizationHeader()
      }
    }
  }
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const AuthGraphQLMiddlewareType = Symbol.for('AuthGraphQLMiddleware')
